import SlideFadeInitial from './SlideFadeInitial';
import SlideFadeIn from './SlideFadeIn';
import SlideInitial from './SlideInitial';
import SlideIn from './SlideIn';
import TitleInitial from './TitleInitial';
import TitleIn from './TitleIn';
import ImageInitial from './ImageInitial';
import ImageIn from './ImageIn';

const animations = new Map();

animations.set('slide-fade-initial', SlideFadeInitial);
animations.set('slide-fade-in', SlideFadeIn);
animations.set('slide-initial', SlideInitial);
animations.set('slide-in', SlideIn);
animations.set('title-initial', TitleInitial);
animations.set('title-in', TitleIn);
animations.set('image-initial', ImageInitial);
animations.set('image-in', ImageIn);

export default animations;
